import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY_NAME } from "../constants/CompanyConstants";

/**
 * Reusable component for setting page meta tags
 * @param {string} title - Page title
 * @param {string} description - Page description for SEO
 * @param {string} keywords - Comma-separated keywords for SEO
 * @param {string} imageUrl - Featured image for social sharing
 * @param {string} path - Current page path (e.g. "/about")
 */
const MetaTags = ({ title, description, keywords, imageUrl, path }) => {
  const fullTitle = title ? `${title} | ${COMPANY_NAME}` : COMPANY_NAME;
  const url = path
    ? `${window.location.origin}${path}`
    : window.location.origin;
  const defaultImage = "/assets/images/logo/logo-1200x628.webp";

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content={COMPANY_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl || defaultImage} />
      {imageUrl && <meta property="og:image:type" content="image/webp" />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl || defaultImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default MetaTags;
